import { ChevronDown } from "lucide-react";

// Native <details> for keyboard accessibility and clean print expansion.
export const Expandable = ({ title, badge, children, testid }) => {
  return (
    <details className="ic-surface group overflow-hidden" data-testid={testid}>
      <summary
        className="flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-4"
        data-testid={testid ? `${testid}-summary` : undefined}
      >
        <span className="flex flex-wrap items-center gap-3">
          <span className="font-head text-base font-semibold">{title}</span>
          {badge && <span className="ic-pill">{badge}</span>}
        </span>
        <ChevronDown
          size={18}
          className="shrink-0 text-[var(--text-2)] transition-transform group-open:rotate-180"
        />
      </summary>
      <div className="border-t border-[var(--border)] px-5 py-4 text-[var(--text-2)]">{children}</div>
    </details>
  );
};
